import type React from "react"
import { useTranslation } from "react-i18next"
import { Link as RouterLink } from "react-router"

import { APP_COMPANY_NAME } from "@/utils/constants"

import { Box, Button, Stack, Typography } from "@mui/material"

import verifyEmailImage from "./verify-email.png"

interface VerifyEmailProps {
  email: string
}

export const VerifyEmail: React.FC<VerifyEmailProps> = ({ email }) => {
  const { t } = useTranslation()

  return (
    <>
      <Typography
        id="verificationSentTitle"
        variant="h1"
        sx={{
          mb: 1.5,
          textAlign: "center",
        }}
      >
        {t("verifyAccount.emailSentTitle")}
      </Typography>
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        <img alt="" aria-hidden="true" src={verifyEmailImage} width="215" />
      </Box>
      <Typography
        sx={{
          textAlign: "center",
        }}
      >
        {t("verifyAccount.emailSentMessage", { email })}
      </Typography>
      <Typography
        sx={{
          mb: 4.5,
          textAlign: "center",
        }}
      >
        {t("verifyAccount.emailSentNextSteps")}
      </Typography>
      <Stack
        spacing={3}
        sx={{
          alignItems: "center",
        }}
      >
        <Button
          color="primary"
          component={RouterLink}
          to="/"
          variant="contained"
        >
          {t("verifyAccount.logInButton", {
            companyName: APP_COMPANY_NAME,
          })}
        </Button>
      </Stack>
    </>
  )
}
